import { render, staticRenderFns } from "./SdgChart.vue?vue&type=template&id=18b04fa4&scoped=true"
import script from "./SdgChart.vue?vue&type=script&lang=ts"
export * from "./SdgChart.vue?vue&type=script&lang=ts"
import style0 from "./SdgChart.vue?vue&type=style&index=0&id=18b04fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b04fa4",
  null
  
)

export default component.exports